import React from 'react';

export default function RotateButton({
  children,
  isApplying,
  setRotatePreviewDeg,
  min = 180,
  max = 180,
  increment = 45,
}) {
  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  return (
    <button
      className="py-1 px-2 rounded-lg bg-lt-brown text-white whitespace-nowrap disabled:opacity-50"
      disabled={isApplying}
      onClick={() =>
        setRotatePreviewDeg((v) => clamp(v + increment, -min, max))
      }
    >
      {children}
    </button>
  );
}
